/**
 * @param {Object} state
 * @returns {Object}
 */
function noopReducer(state = {}) {
  return state;
}

export default noopReducer;
